<template>
  <v-container tag="section">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <parametros ref="parametrosREF" :item="item" :title="title" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-validacao-baixas"
            color="green"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvar()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import TaxaMediaDepreciacaoService from '@/services/TaxaMediaDepreciacaoService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      Parametros: () => import('@/components/taxaMediaDepreciacao/Parametros.vue')
    },
    mixins: [dateFormatterMixins],

    data: () => ({
      item: {
        titulo: '',
        data_base: ''
      },
      loading: false
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Taxa Média de Depreciação' : 'Adicionar Taxa Média de Depreciação';
      }
    },

    mounted() {
      if (this.$route.params.id) this.getById(this.$route.params.id);
    },

    methods: {
      getById(id) {
        TaxaMediaDepreciacaoService.getById(id)
          .then(({ data }) => {
            this.item = {
              titulo: data.data.titulo,
              data_base: data.data.data_base
            };
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar Taxa Média de Depreciação.', '', {
              position: 'topRight'
            });
          });
      },

      salvar() {
        const data = this.$refs.parametrosREF.exportData();
        const id = this.$route.params.id;

        this.loading = true;

        TaxaMediaDepreciacaoService.salvar(data, id)
          .then(() => {
            this.$toast.success('Taxa Média de Depreciação salva com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.push({ name: 'Taxa Média de Depreciação Histórico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar Taxa Média de Depreciação.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
